module.exports = __webpack_public_path__ + "static/img/hct6.8d56fd9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hct/hct6.jpg
// module id = +ca+
// module chunks = 0